import { v4 as uuidv4 } from 'uuid';

export const MOCK_JOBS = [
  "Main St Kitchen Remodel",
  "Oak Ave Bathroom Addition",
  "Riverside Deck Build",
  "Downtown Office Renovation",
  "Maple Dr Basement Finish"
];

export const EXPENSE_TYPES = [
  { id: "material", label: "Materials", icon: "🪵", color: "#e67e3a" },
  { id: "labor",    label: "Labor",     icon: "👷", color: "#3a9be6" },
  { id: "gas",      label: "Gas / Mileage", icon: "⛽", color: "#e6c23a" },
  { id: "rental",   label: "Equipment Rental", icon: "🔧", color: "#9b3ae6" },
  { id: "other",    label: "Other",     icon: "📋", color: "#6b7280" }
];

export let mockExpenses = [
  { expenseId: uuidv4(), type: "material", amount: 847.50, description: "2x4 lumber, plywood sheets, screws", jobName: "Main St Kitchen Remodel", date: "2024-01-15", receiptUrl: null, vendor: "Home Depot" },
  { expenseId: uuidv4(), type: "gas", amount: 68.40, description: "245 miles @ $0.67/mile", jobName: "Oak Ave Bathroom Addition", date: "2024-01-16", receiptUrl: null, vendor: "BP Station" },
  { expenseId: uuidv4(), type: "labor", amount: 1200.00, description: "Subcontractor - tile work (8 hrs)", jobName: "Main St Kitchen Remodel", date: "2024-01-17", receiptUrl: null, vendor: "Mike's Tile Co" },
  { expenseId: uuidv4(), type: "material", amount: 324.99, description: "PEX tubing, fittings, shut-off valves", jobName: "Oak Ave Bathroom Addition", date: "2024-01-17", receiptUrl: null, vendor: "Ferguson Supply" },
  { expenseId: uuidv4(), type: "rental", amount: 185.00, description: "Scissor lift - 1 day", jobName: "Riverside Deck Build", date: "2024-01-18", receiptUrl: null, vendor: "Sunbelt Rentals" },
  { expenseId: uuidv4(), type: "gas", amount: 52.80, description: "189 miles @ $0.67/mile", jobName: "Riverside Deck Build", date: "2024-01-19", receiptUrl: null, vendor: null },
  { expenseId: uuidv4(), type: "material", amount: 2340.00, description: "Composite decking boards - 480 sq ft", jobName: "Riverside Deck Build", date: "2024-01-19", receiptUrl: null, vendor: "84 Lumber" },
  { expenseId: uuidv4(), type: "labor", amount: 960.00, description: "Electrician - panel upgrade (6 hrs)", jobName: "Downtown Office Renovation", date: "2024-01-20", receiptUrl: null, vendor: "Bright Electric LLC" }
];

export function addMockExpense(expense) {
  const newExpense = { ...expense, expenseId: uuidv4() };
  mockExpenses = [newExpense, ...mockExpenses];
  return newExpense;
}

export function deleteMockExpense(expenseId) {
  mockExpenses = mockExpenses.filter(e => e.expenseId !== expenseId);
}
